//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "FormType",

  data: function () {
    return {
      hoverCard: -1
    }
  },

  props: {
    types: {
      type: Array,
      default: () => {
        return []
      }
    },
    form: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  methods: {
    changeType: function (val) {
      this.form.type = val;
      this.$yandexMetrika.reachGoal('type_sert');
      this.$emit("nextStage");
    },
    mouseoverCard: function (index) {
      this.hoverCard = index;
    },
  }
}
